<template>
  <div id="vueVideoPlayer" class="video-player-box">
    <vue-video-player
      class="video-player vjs-custom-skin"
      :class="{ 'disabled-progress': disabledProgress }"
      ref="videoPlayer"
      :playsinline="true"
      :options="playerOptions"
      @play="play"
      @ended="ended"
      @loadedmetadata="loadedmetadata"
      @canplay="canplay"
      @waiting="waiting"
      @pause="pause"
      @timeupdate="timeupdate"
    ></vue-video-player>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'; // 视频播放器
import _ from 'lodash';
export default {
  components: {
    vueVideoPlayer: videoPlayer
  },
  props: {
    disabledProgress: {
      type: Boolean
    },
    src: {
      type: String
    },
    cover_url: {
      type: String
    }
  },
  watch: {
    src: {
      handler() {
        if (this.src) {
          this.playerOptions.sources[0].src = this.src;
        }
      },
      immediate: true
    },
    // disabledProgress: {
    //   handler() {
    //     // ios全屏禁不了进度条控制，ios隐藏全屏按钮
    //     if(this.disabledProgress && this.$tools.ios) {
    //       this.playerOptions.controlBar.fullscreenToggle = false;
    //     } else {
    //       this.playerOptions.controlBar.fullscreenToggle = true;
    //     }
    //   },
    //   immediate: true
    // },
    cover_url: {
      handler() {
        if (this.cover_url) {
          this.playerOptions.poster = this.cover_url;
        } else {
          this.playerOptions.poster = '';
        }
      },
      immediate: true
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  data() {
    return {
      isInit: false,
      // 配置信息
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            src: this.src // 路径
            // type: 'application/x-mpegURL'
            // type: "video/mp4", // 类型
          }
        ],
        // bigPlayButton 默认去掉了播放按钮
        children: [
          'mediaLoader',
          'posterImage',
          'textTrackDisplay',
          'loadingSpinner',
          'liveTracker',
          'controlBar',
          'errorDisplay',
          'textTrackSettings',
          'resizeManager'
        ],
        poster: this.cover_url, // 你的封面地址
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          currentTimeDisplay: true,
          pictureInPictureToggle: false, // 画中画
          audioTrackButton: false, // 音频菜单
          subsCapsButton: false, // 语言菜单
          timeDivider: false, //当前时间和持续时间的分隔符
          durationDisplay: false, //显示持续时间
          remainingTimeDisplay: true, //是否显示剩余时间功能
          fullscreenToggle: false //全屏按钮
        }
      }
    };
  },
  mounted() {
    // ios双击全屏问题
    document.querySelector('.vjs-control-bar').addEventListener('dblclick', function(event) {
      console.log('dblclick2');
      event.preventDefault(); // 阻止默认行为
      event.stopPropagation(); // 阻止事件冒泡
    });
  },
  methods: {
    timeupdate: _.throttle(
      function (e) {
        this.savePlayTime(e.currentTime())
        this.$emit('timeupdate', e);
      },
      2000,
      {
        leading: false,
        trailing: true
      }
    ),
    savePlayTime(time) {
      let videoTimeList = [];
      if(localStorage.videoTimeList) {
        videoTimeList = JSON.parse(localStorage.videoTimeList);
      }
      const curUrl = this.src.split('?')[0];
      // 当前视频数据
      let curData = videoTimeList.find(item => item.url == curUrl);
      if(!curData) {
        // 如果不存在当前视频数据，则添加
        curData = {
          url: curUrl,
        }
        videoTimeList.push(curData);
      }
      // 更新当前数据时间
      curData.cTime = Date.now();
      curData.time = time;
      // 删除24小时前的数据
      videoTimeList = videoTimeList.filter(item => item.cTime > Date.now() - 2 * 60 * 60 * 1000);
      localStorage.videoTimeList = JSON.stringify(videoTimeList);
    },
    play(e) {
      this.$emit('play', e);
    },
    ended(e) {
      this.$emit('ended', e);
    },
    pause(e) {
      this.$emit('pause', e);
    },
    waiting(e) {
      this.$emit('waiting', e);
    },
    canplay(e) {
      this.$emit('canplay', e);
      if(!this.isInit) {
        this.isInit = true;
        // 缓存播放时间
        const videoTimeList = JSON.parse(localStorage.videoTimeList || '[]');
        if(videoTimeList && videoTimeList.length) {
          const curCache = videoTimeList.find(item => item.url == this.src.split('?')[0]);
          if(curCache.cTime > Date.now() - 2 * 60 * 60 * 1000) {
            // 存在2小时内的缓存数据
            this.$refs.videoPlayer.player.currentTime(curCache.time);
          }
        }
      }
    },
    loadedmetadata(e) {
      this.$emit('loadedmetadata', e);
    }
  }
};
</script>
<style lang="scss" scoped>
.video-player-box /deep/ {
  .vjs-current-time {
    display: block;
  }
  .disabled-progress .vjs-progress-control {
    pointer-events: none;
  }
  .vjs-control-bar {
    *:nth-child(n+3) {
      pointer-events: none;
    }
  }
}
</style>
